module.exports = __webpack_public_path__ + "img/settings.de60af97.svg";